import { tv } from 'tailwind-variants';

const inlineMessageStyles = tv({
    slots: {
        container: `
      iris:flex 
      iris:h-fit 
      iris:items-center 
      iris:gap-1
    `,
        label: `
      iris:cursor-text
      iris:font-(family-name:--comp-type-font-input-helper)
      iris:text-(length:--comp-type-size-input-helper)
      iris:leading-(--comp-type-leading-input-helper)!
      iris:font-[var(--comp-type-weight-input-helper)]
      iris:tracking-(--comp-type-tracking-input-helper)
      iris:not-italic
    `,
        iconContainer: `
      iris:inline-flex
      iris:h-(--comp-size-icon-input-helper)
      iris:w-fit
      iris:items-center
      iris:gap-(--comp-space-gap-input-helper)
    `,
        icon: `
      iris:h-(--base-space-px-16) 
      iris:w-(--base-space-px-16)
    `,
    },
    variants: {
        variant: {
            error: "",
        },
    },
    defaultVariants: {
        inverse: false,
        variant: "error",
    },
});

export { inlineMessageStyles as default };
